import React from 'react';
import { Button, Modal } from '@themesberg/react-bootstrap';
import { useTranslation } from 'react-i18next';
import { generateRandomId } from '../../../utils/string';
import ParcelStatusPage from '../../../components/common/parcelStatusPages';
import ExcelDownloadReport from '../../../components/common/excel/download';
import { schemeTypeMap } from '../../../utils/sms/constantsAndUtils';

const BulkAddSchemeModal = (props) => {
  const { showModal, closeModal, data, columns, schemeType } = props;
  const { t } = useTranslation();
  const uploadedData = data.reduce((acc, obj, index) => {
    acc[index + 1] = obj;
    return acc;
  }, {});

  const exportData = (data) => {
    let result = data;
    // switch (schemeType) {
    //   case schemeTypeMap.foc:
    //     const resultData = [];

    //     break;
    //   default:
    //     break;
    // }
    return result;
  };

  return (
    <div>
      <>
        <Modal
          id={generateRandomId()}
          as={Modal.Dialog}
          centered
          show={showModal}
          onHide={closeModal}
          size="xl"
        >
          <Modal.Header>
            <Modal.Title className="h6">
              {t(`All Uploaded Products`)}
            </Modal.Title>
            <div>
              <ExcelDownloadReport
                data={exportData(data)}
                fileName={'Products'}
              />
              <Button variant="close" aria-label="Close" onClick={closeModal} />
            </div>
          </Modal.Header>
          <Modal.Body>
            {Object.keys(uploadedData).length > 0 && (
              <ParcelStatusPage
                tableData={uploadedData}
                tableColumns={columns}
                hideBulkActions={true}
                showDateFilters={false}
                showHeaders={false}
              />
            )}
          </Modal.Body>
        </Modal>
      </>
    </div>
  );
};

export default BulkAddSchemeModal;
